import { useEffect, useState } from "react";
import Navbar from "../../../Navbar";
import Sidebar from "../../../Sidebar";
import {
  deleteServico,
  listAllServicesByPage,
} from "../../../services/ServicoService";
import { CDBTable, CDBSpinner, CDBTableHeader, CDBTableBody } from "cdbreact";
import ServicoForm from "./ServicoForm";
import currencyBRFormat from "../../../util/CurrencyUtils";
import EditarServicoModal from "./EditarServicoModal";
import { toast } from "react-toastify";
import PaginationBootstrap from "../../../components/PaginationBootstrap";

export const Servicos = () => {
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [toggled, setToggled] = useState(false);
  const [pageInfo, setPageInfo] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
    handleSidebarToggle();
    setIsLoading(true);
    listServicosPage();
  }, []);

  function listServicosPage(page) {
    listAllServicesByPage(page)
      .then((response) => {
        setServices(response.data);
        setPageInfo(response.pageInfo);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  function remove(id) {
    const executeAction = window.confirm(
      `Excluir serviço?`
    );

    if (executeAction) {
      deleteServico(id)
        .then((response) => {
          listServicosPage();
          toast.success(response);
        })
        .catch((error) => {
          if (error.response && error.response.status == 422)
            toast.warn(error.response.data);
          else toast.error("Não foi possivel exluir este serviço");
        });
    }
  }

  function calculateLucro(price, cost) {
    return currencyBRFormat(parseFloat(price - cost));
  }

  function handleSidebarToggle() {
    const isMobile = window.innerWidth <= 720;
    if (isMobile) {
      setToggled(true);
    }
  }

  return (
    <div className="d-flex">
      <div>
        <Sidebar toggled={toggled} />
      </div>
      <div className="main-content-wrapper">
        <Navbar toggled={toggled} setToggled={setToggled} />
        <div style={{ height: "100%" }}>
          <div
            style={{
              padding: "20px 5%",
            }}
          >
            <div>
              <div className="mt-3">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="fw-bold text-dark mb-0">Serviços</h3>
                  <ServicoForm listServicos={listServicosPage} />
                  <div className="mb-3 d-flex d-none">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Pesquisar por nome"
                    />
                    <button className="btn btn-primary mx-3">
                      <i className="fa fa-search"></i>
                    </button>
                  </div>
                </div>

                {isLoading ? (
                  <div className="d-flex justify-content-center p-3">
                    <CDBSpinner dark />
                  </div>
                ) : (
                  <>
                    <CDBTable className="alcon-table mt-3" responsiveSm borderless>
                      <thead>
                        <tr>
                          <th>Nome do Serviço</th>
                          <th>Preço</th>
                          <th className="text-end">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {services && services.map((service) => (
                          <tr key={service.id}>
                            <td className="fw-bold">{service.name}</td>
                            <td>
                              <span className="badge bg-light text-dark border p-2 fw-medium">
                                {currencyBRFormat(service.price)}
                              </span>
                            </td>
                            <td className="text-end">
                              <div className="dropdown">
                                <button
                                  className="btn btn-link btn-3-dots text-muted shadow-none p-0"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                >
                                  <i className="fas fa-ellipsis-v"></i> {/* Ícone do FontAwesome fica mais pro */}
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end shadow-lg border-0 rounded-3">
                                  <li>
                                    <EditarServicoModal
                                      listServicos={listServicosPage}
                                      service={service}
                                    />
                                  </li>
                                  <li><hr className="dropdown-divider" /></li>
                                  <li>
                                    <button
                                      onClick={() => remove(service.id)}
                                      className="dropdown-item text-danger d-flex align-items-center"
                                    >
                                      Excluir
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </CDBTable>
                    {services.length > 0 ? (
                      <PaginationBootstrap
                        pageInfo={pageInfo}
                        goToPage={listServicosPage}
                      />
                    ) : (
                      <>Nenhum serviço cadastrado.</>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Servicos;
